/**
 * 用户角色枚举
 */
export var UserRole;
(function (UserRole) {
    UserRole["SYSTEM_ADMIN"] = "SYSTEM_ADMIN";
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["COMPETITION_MANAGER"] = "COMPETITION_MANAGER";
    UserRole["SCHOOL"] = "SCHOOL";
    UserRole["INSTITUTION"] = "INSTITUTION";
    UserRole["CONTESTANT"] = "CONTESTANT";
    UserRole["JUDGE"] = "JUDGE";
    UserRole["COACH"] = "COACH";
    UserRole["VOLUNTEER"] = "VOLUNTEER";
})(UserRole || (UserRole = {}));
/**
 * 证件类型枚举
 */
export var IdType;
(function (IdType) {
    IdType["ID_CARD"] = "ID_CARD";
    IdType["HK_MACAO_PASS"] = "HK_MACAO_PASS";
    IdType["TW_PASS"] = "TW_PASS";
    IdType["PASSPORT"] = "PASSPORT";
    IdType["OTHER"] = "OTHER";
})(IdType || (IdType = {}));
/**
 * 用户状态
 */
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["INACTIVE"] = "INACTIVE";
    UserStatus["SUSPENDED"] = "SUSPENDED";
})(UserStatus || (UserStatus = {}));
/**
 * 档案状态
 */
export var ProfileStatus;
(function (ProfileStatus) {
    ProfileStatus["DRAFT"] = "DRAFT";
    ProfileStatus["PENDING"] = "PENDING";
    ProfileStatus["APPROVED"] = "APPROVED";
    ProfileStatus["REJECTED"] = "REJECTED";
})(ProfileStatus || (ProfileStatus = {}));
/**
 * 证件照片审核状态
 */
export var DocumentReviewStatus;
(function (DocumentReviewStatus) {
    DocumentReviewStatus["PENDING"] = "PENDING";
    DocumentReviewStatus["APPROVED"] = "APPROVED";
    DocumentReviewStatus["REJECTED"] = "REJECTED";
})(DocumentReviewStatus || (DocumentReviewStatus = {}));
//# sourceMappingURL=user.js.map